export enum CpdsAccordionTypes {
    LONG = "LONG",
    SHORT = "SHORT",
    CUSTOM = "CUSTOM"
}
